import { gql } from "@apollo/client";

export const createTrialCalendarMutation = gql`
  mutation CreateTrialCalendar($data: CreateTrialCalendarInput!) {
    createTrialCalendar(data: $data) {
      id
    }
  }
`;

export const getAllJudgeQuery = gql`
  query GetAllJudge($search: String) {
    getAllJudge(search: $search) {
      name
      email
      authId
    }
  }
`;
